import { Slick } from "../../grid/slick.core";
import { createJSLGrid } from "../../grid/slick.creator";
var GridComponent = /** @class */ (function () {
    function GridComponent(data, columns, options, height) {
        var _this = this;
        this.data = data;
        this.columns = columns;
        this.options = options;
        this.currentlyVisible = true;
        this.checkVisibleTimeout = 0;
        this.initEventsFnc = [];
        this.resizeEventListener = function () {
            _this.ref.then(function (g) {
                if (_this.isVisible(g) && !_this.anyInputIsFocused()) {
                    g.resizeCanvas();
                }
            });
        };
        var style = "";
        if (!options.autoHeight) {
            style = "height:" + (height !== null && height !== void 0 ? height : "400px");
        }
        this.rootTag = {
            tag: "div",
            attr: {
                style: style
            }
        };
        this.ref = new Promise(function (resolve, reject) {
            _this.refResolver = resolve;
        });
    }
    GridComponent.prototype.getRootTag = function () {
        return this.rootTag;
    };
    GridComponent.prototype.getRef = function () {
        return this.ref;
    };
    GridComponent.prototype.initEvents = function (fnc) {
        this.initEventsFnc.push(fnc);
    };
    GridComponent.prototype.onCreate = function (vnode) {
        var _this = this;
        // let grid;
        setTimeout(function () {
            if (Array.isArray(_this.data)) {
                _this.gridRef = createJSLGrid(vnode.dom, _this.data, _this.columns, _this.options);
            }
            else {
                var rawData_1 = [];
                _this.gridRef = createJSLGrid(vnode.dom, rawData_1, _this.columns, _this.options);
                _this.data.then(function (result) {
                    for (var i = 0; i < result.length; i++) {
                        rawData_1.push(result[i]);
                    }
                    _this.gridRef.refreshData();
                });
            }
            _this.refResolver(_this.gridRef);
            for (var idx = 0; idx < _this.initEventsFnc.length; idx++) {
                _this.initEventsFnc[idx](_this.gridRef);
            }
            window.addEventListener("resize", _this.resizeEventListener);
            _this.checkVisibility(_this.gridRef);
        }, 1);
    };
    GridComponent.prototype.onRemove = function (vnode) {
        var _this = this;
        if (this.gridRef != null) {
            this.gridRef.destroy();
            this.gridRef = null;
        }
        this.ref = new Promise(function (resolve, reject) {
            _this.refResolver = resolve;
        });
        if (this.checkVisibleTimeout !== 0) {
            clearTimeout(this.checkVisibleTimeout);
        }
        window.removeEventListener("resize", this.resizeEventListener);
    };
    GridComponent.prototype.render = function () {
        return this.rootTag;
    };
    GridComponent.prototype.checkVisibility = function (g) {
        var _this = this;
        if (!this.isVisible(g)) {
            this.currentlyVisible = false;
            this.checkVisibleTimeout = setTimeout(function () { _this.checkVisibility(g); }, 1000);
        }
        else {
            if (!this.currentlyVisible) {
                this.currentlyVisible = true;
                g.invalidateAllRows();
                g.resizeCanvas();
            }
            this.checkVisibleTimeout = 0;
        }
    };
    GridComponent.prototype.anyInputIsFocused = function () {
        // this check is necessary because of mobile virtual keyboard
        // -> virtual keyboard triggers window resize event -> which would reset any editors
        return Slick.GlobalEditorLock.isActive() && document.querySelector("input:focus") != null;
    };
    GridComponent.prototype.isVisible = function (g) {
        var el = g.getViewportNode().parentElement;
        while (el != null && el !== document.body) {
            if (getComputedStyle(el, null).display === "none") {
                return false;
            }
            el = el.parentElement;
        }
        return el != null;
    };
    return GridComponent;
}());
export { GridComponent };
